<div class="terms-container">
  <div class="terms-content">
    <h1>Terms of Service</h1>
    <p class="last-updated">Last updated: {{ getCurrentDate() }}</p>
    
    <section class="terms-section">
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using Five Searches, you accept and agree to be bound by the terms and provision of this agreement.</p>
    </section>

    <section class="terms-section">
      <h2>2. Use License</h2>
      <p>Permission is granted to temporarily download one copy of Five Searches per device for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
      <ul>
        <li>modify or copy the materials</li>
        <li>use the materials for any commercial purpose or for any public display</li>
        <li>attempt to reverse engineer any software contained on the website</li>
        <li>remove any copyright or other proprietary notations from the materials</li>
      </ul>
    </section>

    <section class="terms-section">
      <h2>3. Disclaimer</h2>
      <p>The materials on Five Searches are provided on an 'as is' basis. Five Searches makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
    </section>

    <section class="terms-section">
      <h2>4. Limitations</h2>
      <p>In no event shall Five Searches or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Five Searches, even if Five Searches or a Five Searches authorized representative has been notified orally or in writing of the possibility of such damage.</p>
    </section>

    <section class="terms-section">
      <h2>5. Privacy Policy</h2>
      <p>Your privacy is important to us. Our <a [href]="getPrivacyUrl()" target="_blank">Privacy Policy</a> explains how we collect, use, and protect your information when you use our service.</p>
    </section>

    <section class="terms-section">
      <h2>6. Contact Information</h2>
      <p>If you have any questions about these Terms of Service, please contact us at:</p>
      <p>Email: support&#64;fivesearches.com<br>
      Address: 123 Search Street, Tech City, TC 12345</p>
    </section>
  </div>
</div>
